import { Box, Flex } from '@chakra-ui/react';
import { animate, motion, useMotionValue, useTransform } from 'framer-motion';
import { useEffect } from 'react';

import { TextSemiBold } from 'UiKit/typography';
import SkeletonComponent from 'UiKit/skeleton';
import { ChevronRightIcon } from 'Asset/icon';
import formatCurrency from 'Helper/formatCurrency';
import { Condition, Element } from 'Component/others';

import styles from './styles.module.css';

const OverviewCard = ({ title, count = 0, uom = '', uomPosition = 'left', isNavigable = false, onClick, isCurrency, isLoading, bgColor, valueColor }) => {
  const duration = 2;
  const countProgress = useMotionValue(0);
  const rounded = useTransform(() => (isCurrency ? formatCurrency(Math.round(countProgress.get())) : Math.round(countProgress.get())));

  const leftUom = uom && uomPosition === 'left' ? uom : '';
  const rightUom = uom && uomPosition === 'right' ? uom : '';

  useEffect(() => {
    if (!isLoading) {
      const controls = animate(countProgress, parseInt(count), { duration: duration });
      return () => controls.stop();
    }
  }, [countProgress, duration, count, isLoading]);

  return (
    <Box
      className={`
        ${styles['card-overview__bento-container']}
        ${isNavigable ? styles['card-overview__bento-container--clickable'] : ''}
      `}
      onClick={isNavigable ? onClick : undefined}
    >
      <Flex className={styles['card-overview__title-bento-container']}>
        <TextSemiBold className={styles['card-overview__title-text']}>{title}</TextSemiBold>
      </Flex>

      <Condition statement={!isLoading} fallback={<SkeletonComponent height="20px" width="36px" />}>
        <Flex justifyContent="space-between" alignItems="center">
          <Box
            className={styles['card-overview__bento-count']}
            backgroundColor={bgColor}
            color={valueColor}
            minWidth={bgColor && '24px'}
            padding={bgColor && '1px 6px'}
          >
            <Element value={leftUom} />
            <motion.pre className={styles['card-overview__bento-count-text']}>{rounded}</motion.pre>
            <Element value={rightUom} />
          </Box>
          <Condition statement={isNavigable}>
            <ChevronRightIcon size="16px" />
          </Condition>
        </Flex>
      </Condition>
    </Box>
  );
};

export default OverviewCard;
